module.exports = __webpack_public_path__ + "df5caf884d1d958de9a3db17f2da268d.png";